export default __webpack_public_path__ + "static/media/others-1.47cd2f32.JPG";